import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCurrencyFromCountry } from "../../../../utils/constants";
import Check from "../../../../assets/icons/check1.svg";
import { getAllEducationAction } from "../../../../redux/actions/educationActions";
import {
  getOtherUserAction,
  getProfileAction,
} from "../../../../redux/actions/profileActions";
import Uncheck from "../../../../assets/icons/uncheck.svg";
import { logProfileVisits } from "../../../../redux/actions/insightActions";
import {
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CustomButton from "../../../../components/CustomButton";
import {
  deleteBankAccount,
  withdrawFromWallet,
  transferFromAvailable,
} from "../../../../redux/actions/walletActions";
import CustomInput from "../../../../components/CustomInput";
import { getAccountBalance } from "../../../../redux/actions/walletActions";
import cogoToast from "cogo-toast";
import CountryGateModal from "../../../../components/CountryGateModal";
import { isCountryMissing } from "../../../../utils/countryHelpers";

const Account = ({ account, refreshList, transfer, type }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [checked, setChecked] = useState(false);
  const { profile, auth } = useSelector((store) => store);
  const { profileData } = profile;
  const { userData } = auth;

  const userCurrency =
    getCurrencyFromCountry(userData?.country)?.toUpperCase() || "USD";
  const { id, stage } = useParams();
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    amount: "",
    password: "",
  });

  useEffect(() => {
    Promise.all([getProfileAction(dispatch), getAllEducationAction(dispatch)]);
  }, [dispatch]);

  useEffect(() => {
    console.log(id);
    if (id) {
      getOtherUserAction(dispatch, id);
      logProfileVisits(dispatch, id);
    }
  }, [dispatch, id]);

  const handleClick = () => {
    setChecked(!checked);
  };

  const handleDelete = (id) => {
    Promise.resolve(deleteBankAccount(dispatch, id)).finally(() => {
      refreshList();
    });
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const [showCountryModal, setShowCountryModal] = useState(false);

  const handleChange = ({ target: { id, value } }) => {
    const newValue = {};
    newValue[id] = value;
    setState({ ...state, ...newValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const currentCountry = profileData?.country || userData?.country;
    if (isCountryMissing(currentCountry)) {
      cogoToast.error("Please select your country to activate your wallet");
      setShowCountryModal(true);
      return;
    }

    setLoading(true);
    if (transfer) {
      const payload = {
        amount: parseFloat(state.amount * 100),
        password: state.password,
      };
      Promise.resolve(transferFromAvailable(dispatch, payload)).finally(() => {
        setOpenDialog(false);
        setLoading(false);
        getAccountBalance(dispatch);
      });
    } else {
      let payload;
      if (type === "paystack") {
        payload = {
          account_number: account.account_number,
          bank_code: account.bankCode,
          type: "nuban",
          currency: "NGN",
          amount: parseFloat(state.amount * 100),
        };
      } else {
        payload = {
          account_number: account.account_number,
          bank_code: account.bankCode,
          type: "stripe",
          currency: userCurrency,
          amount: parseFloat(state.amount * 100),
        };
      }

      Promise.resolve(withdrawFromWallet(dispatch, payload)).finally(() => {
        setOpenDialog(false);
        setLoading(false);
      });
    }
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>

        {/* Bank info row */}
        {!transfer && (
          <div className={classes.bankRow}>
            <div className={classes.bankInfo}>
              {/* Bank avatar */}
              <div className={classes.bankAvatar}>
                {account.bank?.substring(0, 2).toUpperCase()}
              </div>
              <div>
                <div className={classes.bankName}>{account.bank}</div>
                <div className={classes.accountNumber}>
                  {"**** " + account.account_number.substring(6)}
                </div>
              </div>
            </div>
            <img
              src={checked ? Check : Uncheck}
              alt="check"
              style={{ width: "20px", cursor: "pointer" }}
              onClick={handleClick}
            />
          </div>
        )}

        {/* Account name or transfer label */}
        <Typography variant="body2" className={classes.accountName}>
          {transfer
            ? "Transfer from available balance to book balance"
            : account.account_name}
        </Typography>

        {/* Transfer warning */}
        {transfer && (
          <div className={classes.warningBox}>
            <span className={classes.warningDot} />
            Amount transferred to book balance can no longer be withdrawn
          </div>
        )}

        {/* Action buttons */}
        <div className={classes.actions}>
          <CustomButton
            backgroundColor="#3A6ED4"
            color="#fff"
            text={transfer ? "Transfer" : "Withdraw"}
            additionalClass="mt-3 mb-1"
            handleClick={() => setOpenDialog(true)}
          />
          {!transfer && (
            <div className={classes.deleteRow}>
              <Link
                to="#"
                onClick={() => handleDelete(account.id)}
                className={classes.deleteLink}
              >
                Remove account
              </Link>
            </div>
          )}
        </div>

        {/* Dialog */}
        <Dialog
          open={openDialog}
          onClose={handleClose}
          aria-labelledby="withdrawal-dialog-title"
          PaperProps={{
            style: {
              width: "400px",
              borderRadius: "12px",
              padding: "8px",
            },
          }}
        >
          <DialogTitle
            id="withdrawal-dialog-title"
            disableTypography
            style={{ paddingBottom: "4px" }}
          >
            <div style={{ fontSize: "16px", fontWeight: 600, color: "#032250" }}>
              {transfer ? "Transfer funds" : "Withdraw funds"}
            </div>
            <div style={{ fontSize: "13px", color: "#7F91A7", marginTop: "4px", fontWeight: 400 }}>
              Enter the amount and confirm your password
            </div>
          </DialogTitle>
          <DialogContent>
            <form onSubmit={handleSubmit} style={{ paddingTop: "8px" }}>
              <CustomInput
                name="amount"
                type="number"
                id="amount"
                label="Amount"
                isRequired={true}
                placeholder="Enter amount"
                value={state.amount}
                onChange={handleChange}
              />
              <CustomInput
                name="password"
                type="password"
                id="password"
                label="Password"
                isRequired="true"
                placeholder="Enter your password"
                value={state.password}
                onChange={handleChange}
              />
              <CustomButton
                backgroundColor="#3A6ED4"
                color="#fff"
                type="submit"
                text={transfer ? "Confirm Transfer" : "Confirm Withdrawal"}
                additionalClass="mt-4 mb-2"
                loading={loading}
                disabled={[!state.amount, !state.password].includes(true)}
              />
            </form>
          </DialogContent>
        </Dialog>

        <CountryGateModal
          open={showCountryModal}
          onClose={() => setShowCountryModal(false)}
          onSuccess={() => {
            setShowCountryModal(false);
            getAccountBalance(dispatch);
            getProfileAction(dispatch);
          }}
          allowDismiss={true}
        />
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles({
  card: {
    background: "#FFFFFF",
    boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.07)",
    border: "1px solid #EFEFEF",
    borderRadius: "12px",
    marginBottom: "16px",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    },
  },
  cardContent: {
    padding: "20px 24px !important",
  },
  bankRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  bankInfo: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  bankAvatar: {
    width: "38px",
    height: "38px",
    borderRadius: "8px",
    background: "#EAF0FB",
    color: "#3A6ED4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 700,
    flexShrink: 0,
  },
  bankName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#032250",
  },
  accountNumber: {
    fontSize: "12px",
    color: "#7F91A7",
    marginTop: "2px",
  },
  accountName: {
    fontSize: "13px",
    color: "#7F91A7",
    marginBottom: "4px",
  },
  warningBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: "7px",
    background: "#FFF5F5",
    border: "1px solid #FFD6D6",
    borderRadius: "8px",
    padding: "10px 12px",
    fontSize: "12px",
    color: "#B91C1C",
    marginTop: "10px",
    lineHeight: "1.5",
  },
  warningDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "#EF4444",
    flexShrink: 0,
    marginTop: "4px",
  },
  actions: {
    marginTop: "8px",
  },
  deleteRow: {
    display: "flex",
    justifyContent: "center",
    marginTop: "6px",
  },
  deleteLink: {
    fontSize: "13px",
    color: "#7F91A7",
    textDecoration: "none",
    "&:hover": {
      color: "#EF4444",
      textDecoration: "underline",
    },
  },
});

export default Account;